module.exports = __webpack_public_path__ + "img/fenghuangxinwen.dda56d6a.png";